import { Content, isFilled, asText } from "@prismicio/client"
import { SliceComponentProps } from "@prismicio/react"
import { PrismicRichText } from "@airplan/ui/prismic-richtext"
import useDocumentsFiles from "@airplan/hooks/document-files"
import Section from "@aura-design/system/section"
import Grid from "@aura-design/system/grid"
import Separator from "@aura-design/system/separator"
import Button from "@aura-design/system/button"
import { DownloadIcon } from "@radix-ui/react-icons"
import Accordion from "@aura-design/system/accordion"
import Skeleton from "@aura-design/system/dist/components/skeleton"

/**
 * Props for `DynamicDocuments`.
 */
export type DynamicDocumentsProps =
  SliceComponentProps<Content.DynamicDocumentsSlice>

/**
 * Component for "DynamicDocuments" Slices.
 */
const DynamicDocuments = ({ slice }: DynamicDocumentsProps): JSX.Element => {
  const files = useDocumentsFiles({ tags: slice.primary.tags?.split(";") })

  return (
    <Section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
    >
      {files.isLoading ? (
        <>
          <Grid col="one">
            {Array.from({ length: 2 }).map((_, i) => (
              <Skeleton className="fluid" heightAspectRation={5} key={i} />
            ))}
          </Grid>
        </>
      ) : files.isError ? (
        <></>
      ) : files.data.results.length === 0 ? (
        <></>
      ) : files.data.results.length > 2 ? (
        <>
          <Accordion
            title={
              <>
                <div className="span-3 text-dark-blue">
                  <span className="h6 font-medium">
                    {" "}
                    {asText(slice.primary.title)}{" "}
                  </span>
                </div>
              </>
            }
          >
            <Grid col="twelve">
              <div className="span-3" />
              <div className="span-9">
                <Grid col="one">
                  {files.data.results.map((item, index) => (
                    <div key={`${slice.id}-${index}`}>
                      <Grid col="twelve">
                        <div className="span-10 valign">
                          <span>{item.data.title}</span>
                        </div>
                        <div className="span-2">
                          <Button
                            className="circle h-4 w-4 relative text-dark-yellow"
                            href={`/api/files/syncfiledocs?name=${item.data.filename}`}
                          >
                            <DownloadIcon className="action icon h5" />
                          </Button>
                        </div>
                      </Grid>
                      <Separator />
                    </div>
                  ))}
                </Grid>
              </div>
            </Grid>
          </Accordion>
          <Separator />
        </>
      ) : (
        <Grid col="twelve">
          <div className="span-3 text-dark-blue">
            <span className="h6 font-medium">
              {" "}
              {asText(slice.primary.title)}{" "}
            </span>
          </div>
          <div className="span-9">
            <Grid col="one">
              {files.data.results.map((item, index) => (
                <div key={`${slice.id}-${index}`}>
                  <Grid col="twelve">
                    <div className="span-10 valign">
                      <span>{item.data.title}</span>
                    </div>
                    <div className="span-2">
                      <Button
                        className="circle h-4 w-4 relative text-dark-yellow"
                        href={`/api/files/syncfiledocs?name=${item.data.filename}`}
                        target="_blank"
                      >
                        <DownloadIcon className="action icon h5" />
                      </Button>
                    </div>
                  </Grid>
                  <Separator />
                </div>
              ))}
            </Grid>
          </div>
        </Grid>
      )}
    </Section>
  )
}

export default DynamicDocuments
